import { render, staticRenderFns } from "./SingleCareer.vue?vue&type=template&id=4fec8ecc&"
import script from "./SingleCareer.vue?vue&type=script&lang=js&"
export * from "./SingleCareer.vue?vue&type=script&lang=js&"
import style0 from "./SingleCareer.vue?vue&type=style&index=0&id=4fec8ecc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports